import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const EditIcon = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M4.23 15.77h.865l8.927-8.926-.866-.866-8.925 8.93v.861Zm-.768.768V14.58l10.88-10.903a.866.866 0 0 1 .255-.16.785.785 0 0 1 .297-.055.859.859 0 0 1 .578.22l.85.853c.079.082.134.171.167.268a.903.903 0 0 1-.004.594.714.714 0 0 1-.163.256L5.42 16.539H3.462Zm10.12-10.12-.426-.44.866.866-.44-.427Z"
    />
  </Svg>
)
export default EditIcon
